import {
  DollarCircleOutlined,
  FileTextOutlined,
  SendOutlined,
  ShoppingCartOutlined,
  SmileOutlined,
  SyncOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";

export const purchaseSteps = [
  {
    title: "Purchase Request",
    description:
      "Initiate material, goods, or service requests with streamlined approval.",
    icon: SmileOutlined,
    bg: "#e6f7ff",
    color: "#1890ff",
  },
  {
    title: "Purchase Order",
    description: "Issue official purchase orders to suppliers.",
    icon: FileTextOutlined,
    bg: "#f6ffed",
    color: "#52c41a",
  },
  {
    title: "Goods Received Note (GRN)",
    description:
      "Track materials received, even with partial shipments. Generate multiple GRNs when suppliers deliver in phases.",
    icon: ShoppingCartOutlined,
    bg: "#e6f7ff",
    color: "#1890ff",
  },
  {
    title: "Proforma Invoice",
    description: "Send pre-invoice documents with a single click.",
    icon: SendOutlined,
    bg: "#f9f0ff",
    color: "#722ed1",
  },
  {
    title: "Quality Report",
    description:
      "Assess the received materials. Separate good stock from rejected materials for quality control.",
    icon: CheckCircleOutlined,
    bg: "#fff7e6",
    color: "#fa8c16",
  },
  {
    title: "Purchase Invoice",
    description:
      "Punch supplier invoices directly linked to corresponding GRNs and purchase orders.",
    icon: DollarCircleOutlined,
    bg: "#fff1f0",
    color: "#f5222d",
  },
  {
    title: "Credit/Debit Note",
    description:
      "Handle purchase returns and supplier adjustments with precision and clarity.",
    icon: SyncOutlined,
    bg: "#f0f0f0",
    color: "#8c8c8c",
  },
];

export enum purchaseFeatureText {
  HERO_TITLE = "Purchase Management Made Smart ",
  HERO_DESCRIPTION = `Seamlessly Manage Your Entire Procurement Process with Ease Margin Welcome to the Purchase Management Module of Ease Margin – a powerful, end-to-end solution to simplify, automate, and control your purchasing workflow. From raising purchase requests to handling invoices and supplier adjustments, we connect every step into one smart, efficient system.`,
  HERO_BUTTON = "Get Started for Free",

  INTRO_TITLE = "💼 Why Purchase the Old Way? Go Smart with Ease Margin.",
  INTRO_DESCRIPTION = `Say goodbye to inefficient emails, disconnected spreadsheets, and approval bottlenecks. With Ease Margin, every procurement step is linked, traceable, and fully under your control.`,

  SALES_FLOW_TITLE = "🔁 Visualize and Control Every Purchase Step",
  MULTI_FORMAT_TITLE = "🗂️ Multi-Format Purchase Documents: Flexibility Built In",
  DASHBOARD_TITLE = "📈 See Purchase Status in Real-Time: Dynamic Dashboard",
  ADVANTAGE_TITLE = "⚙️ Why Choose Ease Margin for Purchase Management?",
  DOC_FORMAT = "📝 Generate Documents in Multiple Formats",
  SHARING_STORE = "☁️ Seamless Sharing & Storage",

  PERFECT_FOR_TITLE = "🏢 Perfect For:",
  CTA_TITLE = "🚀 Start Using Smart Purchase Management Today.",

  CTA_DESCRIPTION = `Upgrade your procurement process to a fully connected, transparent, and efficient system with Ease Margin.`,
  CTA_BUTTON = "Contact Us for a Free Demo",
}

export const purchaseTemplates = [
  {
    icon: "🧾",
    title: "Customizable Templates",
    description:
      "Add your company logo, terms & conditions, and other company information (excluding bank details). Use pre-built templates for each purchase document type.",
  },
  {
    icon: "📁",
    title: "Smart Document Repository",
    description:
      "Organized, searchable purchase records with filters by supplier, status, document type, and date.",
  },
];

export const purchaseFeaturedCards = [
  {
    icon: "✨",
    title: "Additional Smart Features",
    description:
      "Take your purchase management to the next level with these advanced capabilities:",
  },
  {
    icon: "🔗",
    title: "Auto-Linked Documents:",
    description:
      "Purchase Orders, GRNs, Invoices, and Debit/Credit Notes are automatically linked for complete traceability.",
  },
  {
    icon: "📦",
    title: "Supplier-Wise Pending Material Tracking:",
    description:
      "Instantly view what is pending from each supplier, whether partial or complete deliveries.",
  },
  {
    icon: "🚫",
    title: "Material Rejection Handling:",
    description:
      "Easily manage rejected items and ensure they are excluded from stock and invoicing.",
  },
  {
    icon: "⏰",
    title: "Smart Notifications & Reminders:",
    description:
      "Stay informed about pending approvals, delayed deliveries, and upcoming payment deadlines.",
  },
  {
    icon: "✅",
    title: "Approval Workflow Integration:",
    description:
      "Built-in approval stages for purchase requests and orders for tighter control.",
  },
  {
    icon: "📊",
    title: "Vendor Performance Reports:",
    description:
      "Track supplier reliability, delivery timelines, and quality scores to improve purchasing decisions.",
  },
];

export const purchaseDashboardFeatures = [
  "Visual procurement pipelines",
  "Document status widgets",
  "Pending approvals & goods tracking",
  "Supplier-wise summaries ",
  "Live alerts & reminders for pending documents",
];

export const purchaseAdvantages = [
  "Seamless Procurement Workflow",
  "Real-Time Visibility & Quality Control",
  "Multiple Document Format Support",
  "Automated Material and Invoice Linking",
  "Detailed Quality Reporting",
  "Accurate Stock and Financial Records",
  "Clear, Professional Documents for Every Step",
];

export const purchaseTargetAudience = [
  "Trading Companies",
  "Manufacturers",
  "Distributors",
  "SMEs looking to digitize their sales process",
];
